
import { useState } from 'react';

export default function Home() {
  const [email, setEmail] = useState('');

  const featuredProducts = [
    {
      id: 1,
      name: 'BPC-157 Peptide',
      category: 'Healing & Recovery',
      price: '$89.99',
      image: 'https://public.readdy.ai/ai/img_res/f037c4b5f8f2d9c8c6ca40b0d96bb333.jpg',
      benefits: ['Accelerated healing', 'Gut health support', 'Anti-inflammatory'],
      research: '15+ clinical studies'
    },
    {
      id: 2,
      name: 'NAD+ Booster',
      category: 'Anti-Aging',
      price: '$124.99',
      image: 'https://readdy.ai/api/search-image?query=NAD%20supplement%20bottle%20with%20hologram%20seal%2C%20premium%20white%20background%2C%20pharmaceutical%20grade%20packaging%2C%20professional%20product%20photography%2C%20clean%20medical%20aesthetic&width=400&height=400&seq=2&orientation=squarish',
      benefits: ['Cellular energy', 'DNA repair', 'Longevity support'],
      research: '20+ clinical studies'
    },
    {
      id: 3,
      name: 'Vitamin D3 + K2',
      category: 'Essential Vitamins',
      price: '$34.99',
      image: 'https://readdy.ai/api/search-image?query=vitamin%20D3%20K2%20supplement%20bottle%20with%20security%20hologram%2C%20white%20clean%20background%2C%20premium%20pharmaceutical%20packaging%2C%20professional%20medical%20product%20photography&width=400&height=400&seq=3&orientation=squarish',
      benefits: ['Bone health', 'Immune support', 'Heart health'],
      research: '50+ clinical studies'
    }
  ];

  const educationalTopics = [
    {
      title: 'Understanding Peptides',
      description: 'Learn how peptides work at the cellular level to support healing and wellness',
      icon: 'ri-microscope-line',
      readTime: '5 min read'
    },
    {
      title: 'Anti-Aging Science',
      description: 'Discover the latest research on longevity and cellular health optimization',
      icon: 'ri-heart-pulse-line',
      readTime: '7 min read'
    },
    {
      title: 'Dosage Guidelines',
      description: 'Expert recommendations for safe and effective supplementation protocols',
      icon: 'ri-medicine-bottle-line',
      readTime: '4 min read'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gradient-to-r from-emerald-800 to-emerald-700 shadow-lg sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/50f4002bde5ecf02750e3107d0496ef3/6a239c96e95cb1d44ac1fc74f816ec27.png" 
                alt="Ageless BioScience"
                className="h-10 w-auto"
              />
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="#products" className="text-white hover:text-yellow-300 font-medium cursor-pointer">Products</a>
              <a href="#education" className="text-white hover:text-yellow-300 font-medium cursor-pointer">Education</a>
              <a href="#research" className="text-white hover:text-yellow-300 font-medium cursor-pointer">Research</a>
              <a href="#about" className="text-white hover:text-yellow-300 font-medium cursor-pointer">About</a>
            </nav>
            <button className="bg-yellow-400 text-emerald-900 px-6 py-2 rounded-full hover:bg-yellow-300 transition-colors font-semibold whitespace-nowrap cursor-pointer">
              Shop Now
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat py-20 lg:py-32"
        style={{
          backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.8)), url('https://readdy.ai/api/search-image?query=active%20healthy%20elderly%20person%20exercising%20outdoors%2C%20vibrant%20senior%20citizen%20running%20or%20doing%20yoga%2C%20anti-aging%20wellness%20concept%2C%20energetic%20older%20adult%20staying%20fit%20and%20youthful%2C%20bright%20natural%20lighting%2C%20inspiring%20healthy%20aging%20lifestyle%2C%20stop%20the%20clock%20concept%2C%20vitality%20and%20longevity&width=1200&height=600&seq=5&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="w-full">
              <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                Stop the Clock,
                <span className="text-emerald-700 block">Stay Ageless</span>
              </h1>
              <p className="text-xl text-gray-700 mb-8 leading-relaxed">
                Revolutionary anti-aging peptides and vitamins that help you stay young, healthy, and active regardless of your chronological age. Experience vitality at every stage of life.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <button className="bg-emerald-700 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-emerald-800 transition-colors whitespace-nowrap cursor-pointer">
                  Explore Products
                </button>
                <button className="border-2 border-emerald-700 text-emerald-700 px-8 py-4 rounded-full text-lg font-semibold hover:bg-emerald-50 transition-colors whitespace-nowrap cursor-pointer">
                  View Research
                </button>
              </div>
              <div className="flex items-center space-x-6 text-sm text-gray-600">
                <div className="flex items-center">
                  <i className="ri-shield-check-line text-emerald-700 mr-2"></i>
                  Third-party tested
                </div>
                <div className="flex items-center">
                  <i className="ri-award-line text-emerald-700 mr-2"></i>
                  GMP certified
                </div>
                <div className="flex items-center">
                  <i className="ri-truck-line text-emerald-700 mr-2"></i>
                  Free shipping
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Indicators */}
      <section className="py-12 bg-gradient-to-r from-yellow-50 to-yellow-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-emerald-700 mb-2">10,000+</div>
              <div className="text-gray-700">Happy Customers</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-emerald-700 mb-2">99.9%</div>
              <div className="text-gray-700">Purity Guaranteed</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-emerald-700 mb-2">100+</div>
              <div className="text-gray-700">Research Studies</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-emerald-700 mb-2">24/7</div>
              <div className="text-gray-700">Expert Support</div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section id="products" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Featured Products</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover our most popular peptides and vitamins, each backed by extensive research and manufactured to the highest standards.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
            {featuredProducts.map((product) => (
              <div key={product.id} className="bg-white border-2 border-emerald-100 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl hover:border-emerald-300 transition-all cursor-pointer">
                <div className="aspect-square bg-gradient-to-br from-emerald-50 to-yellow-50 p-8">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="p-6">
                  <div className="text-sm text-emerald-700 font-semibold mb-2 uppercase tracking-wide">{product.category}</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{product.name}</h3>
                  <div className="space-y-2 mb-4">
                    {product.benefits.map((benefit, index) => (
                      <div key={index} className="flex items-center text-sm text-gray-600">
                        <i className="ri-check-line text-emerald-700 mr-2"></i>
                        {benefit}
                      </div>
                    ))}
                  </div>
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-2xl font-bold text-emerald-700">{product.price}</span>
                    <span className="text-sm text-gray-500">{product.research}</span>
                  </div>
                  <button className="w-full bg-gradient-to-r from-emerald-700 to-emerald-600 text-white py-3 rounded-full font-semibold hover:from-emerald-800 hover:to-emerald-700 transition-all whitespace-nowrap cursor-pointer">
                    View Details & Order
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <button className="bg-white text-emerald-700 border-2 border-emerald-700 px-8 py-3 rounded-full font-semibold hover:bg-emerald-50 transition-colors whitespace-nowrap cursor-pointer">
              View All Products
            </button>
          </div>
        </div>
      </section>

      {/* Education Section */}
      <section id="education" className="py-20 bg-gradient-to-br from-emerald-50 via-yellow-50 to-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Health Education Center</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Stay informed with the latest research and expert insights on peptides, vitamins, and wellness optimization.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {educationalTopics.map((topic, index) => (
              <div key={index} className="bg-white border-2 border-emerald-200 rounded-2xl p-8 hover:shadow-lg hover:border-yellow-300 transition-all cursor-pointer">
                <div className="w-16 h-16 bg-gradient-to-br from-emerald-700 to-emerald-600 rounded-full flex items-center justify-center mb-6">
                  <i className={`${topic.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{topic.title}</h3>
                <p className="text-gray-600 mb-4">{topic.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-emerald-700 font-medium">{topic.readTime}</span>
                  <i className="ri-arrow-right-line text-emerald-700"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Research Commitment */}
      <section id="research" className="py-20 bg-gradient-to-br from-emerald-900 via-emerald-800 to-emerald-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.05) 35px, rgba(255,255,255,.05) 70px)`
          }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6">Science-Backed Formulations</h2>
              <p className="text-xl text-emerald-100 mb-8">
                Every product in our catalog is supported by peer-reviewed research and clinical studies. 
                We believe in transparency and provide complete access to research abstracts and safety data.
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-flask-line text-yellow-400 text-xl mr-4"></i>
                  <span>Rigorous third-party testing</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-file-text-line text-yellow-400 text-xl mr-4"></i>
                  <span>Complete research documentation</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-shield-check-line text-yellow-400 text-xl mr-4"></i>
                  <span>Safety and interaction profiles</span>
                </div>
              </div>
              <button className="bg-yellow-400 text-emerald-900 px-8 py-3 rounded-full font-semibold hover:bg-yellow-300 transition-colors whitespace-nowrap cursor-pointer">
                Explore Research Library
              </button>
            </div>
            <div className="bg-emerald-800/50 backdrop-blur-sm border-2 border-yellow-400/30 rounded-2xl p-8">
              <h3 className="text-2xl font-bold mb-6 text-yellow-400">What You'll Find for Each Product:</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-information-line text-yellow-400 mt-1 mr-3"></i>
                  <div>
                    <div className="font-semibold">What It Is</div>
                    <div className="text-emerald-200 text-sm">Detailed molecular description and mechanism</div>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-search-line text-yellow-400 mt-1 mr-3"></i>
                  <div>
                    <div className="font-semibold">What Research Suggests</div>
                    <div className="text-emerald-200 text-sm">Latest findings from clinical studies</div>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-heart-line text-yellow-400 mt-1 mr-3"></i>
                  <div>
                    <div className="font-semibold">Potential Benefits</div>
                    <div className="text-emerald-200 text-sm">Evidence-based health outcomes</div>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-medicine-bottle-line text-yellow-400 mt-1 mr-3"></i>
                  <div>
                    <div className="font-semibold">How It's Used (Dosage)</div>
                    <div className="text-emerald-200 text-sm">Expert-recommended protocols</div>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-file-list-line text-yellow-400 mt-1 mr-3"></i>
                  <div>
                    <div className="font-semibold">Study Abstracts & Sources</div>
                    <div className="text-emerald-200 text-sm">Direct links to peer-reviewed research</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-20 bg-gradient-to-r from-emerald-50 via-emerald-100 to-emerald-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-emerald-900 mb-4">Stay Updated on Wellness Research</h2>
          <p className="text-xl text-emerald-700 mb-8">
            Get the latest studies, product updates, and expert insights delivered to your inbox.
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 px-6 py-3 rounded-full text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-400 border-2 border-emerald-200"
              required
            />
            <button 
              type="submit"
              className="bg-yellow-400 text-emerald-900 px-8 py-3 rounded-full font-semibold hover:bg-yellow-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-emerald-900 via-emerald-800 to-emerald-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <img 
                src="https://static.readdy.ai/image/50f4002bde5ecf02750e3107d0496ef3/6a239c96e95cb1d44ac1fc74f816ec27.png" 
                alt="Ageless BioScience"
                className="h-8 w-auto mb-4"
              />
              <p className="text-emerald-200 mb-4">
                Premium peptides and vitamins for optimal health and wellness.
              </p>
              <div className="flex space-x-4">
                <i className="ri-facebook-fill text-xl text-emerald-300 hover:text-yellow-400 cursor-pointer"></i>
                <i className="ri-twitter-fill text-xl text-emerald-300 hover:text-yellow-400 cursor-pointer"></i>
                <i className="ri-instagram-line text-xl text-emerald-300 hover:text-yellow-400 cursor-pointer"></i>
                <i className="ri-linkedin-fill text-xl text-emerald-300 hover:text-yellow-400 cursor-pointer"></i>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4 text-yellow-400">Products</h4>
              <ul className="space-y-2 text-emerald-200">
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">Peptides</a></li>
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">Vitamins</a></li>
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">Supplements</a></li>
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">Bundles</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4 text-yellow-400">Education</h4>
              <ul className="space-y-2 text-emerald-200">
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">Research Library</a></li>
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">Dosage Guides</a></li>
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">Safety Information</a></li>
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">Blog</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4 text-yellow-400">Support</h4>
              <ul className="space-y-2 text-emerald-200">
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">Contact Us</a></li>
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">FAQ</a></li>
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">Shipping</a></li>
                <li><a href="#" className="hover:text-yellow-400 cursor-pointer">Returns</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-emerald-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-emerald-300 text-sm">
              © 2024 Ageless BioScience. All rights reserved.
            </p>
            <a href="https://readdy.ai/?origin=logo" className="text-emerald-300 hover:text-yellow-400 text-sm cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
